export default __webpack_public_path__ + "assets/images/da07b30b86a83663c213e05e99df2154.png";